export const title = "Laporan Masalah Trailer";

export const tableWidth = "w-[53.5rem]";

export const paramSettings = [
  {
    name: "dari",
    field: "tanggal",
    type: "date",
    format: "yyyy-MM-dd 00:00:00",
    operator: ">=",
    default: new Date(),
    nullable: false,
  },
  {
    name: "sampai",
    field: "tanggal",
    type: "date",
    format: "yyyy-MM-dd 23:59:59",
    operator: "<=",
    default: new Date(),
    nullable: false,
  },
];

export const generateDefaultReportParams = () => {
  const defaultParam = {};

  for (let param of paramSettings) {
    defaultParam[param.name] = param.default;
  }

  return defaultParam;
};

export const groupSetting = {
  name: "Trailer",
  field: "data_trailer.nomor",
  data_field: "data_trailer",
};

export const columnSettings = [
  {
    name: "NO",
    field: "no",
    type: "number",
    width: "w-[3.5rem]",
    layout: "col-start-center",
  },
  {
    name: "TANGGAL",
    field: "tanggal",
    type: "date",
    format: "dd MMM yyyy",
    width: "w-[7rem]",
    layout: "col-start-start",
  },
  {
    name: "DURASI",
    field: "durasi",
    type: "number",
    width: "w-[5rem]",
    layout: "col-start-end",
  },
  {
    name: "GROUP",
    field: "label_grup",
    type: "string",
    width: "w-[12rem]",
    layout: "col-start-start",
  },
  {
    name: "KETERANGAN",
    field: "keterangan",
    type: "string",
    layout: "col-start-start",
    width: "w-[26rem]",
  },
];
